import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Rol } from 'src/app/shared/models/rol.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rol-create-modal',
  templateUrl: './rol-create-modal.component.html',
  styleUrls: ['./rol-create-modal.component.scss']
})
export class RolCreateModalComponent implements OnInit {

  rolForm: FormGroup;
  @Input() rol: Rol;
  isEdit: boolean;

  constructor(public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.rolForm = this.formBuilder.group({
      rol_id     : [0],
      name       : ['', [Validators.required, Validators.maxLength(25)]],
      description: ['', [Validators.maxLength(250)]]
    });

    if (this.rol) {
      this.isEdit = true;
      this.rolForm.patchValue({
          rol_id     : this.rol.rol_id,
          name       : this.rol.name,
          description: this.rol.description
        });

        this.rolForm.updateValueAndValidity();
    }
  }

  close() {
    this.activeModal.close(
      this.rolForm.value
    );
  }
}
